import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CacheService } from './services/cache.service';
import { CacheRunService } from './run/cache-run.service';

export function init_app (cacheRunService: CacheRunService) {
    return () => cacheRunService.initializeApp();
}

@NgModule({
    providers: [
        CacheService,
        {
            provide: APP_INITIALIZER,
            useFactory: init_app,
            deps: [CacheRunService],
            multi: true,
        },
    ],
})
export class CacheModule {}
